import React from 'react';
import { observer } from 'mobx-react-lite';
import { AccountConfigState } from 'src/components/LicenseConfig/AccountConfig/AccountConfigState';
import { Alert } from 'src/domains/common/components/alert/alert';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';
import { AlertWrapper } from './AccountConfigDisplay.style';
import { ConfigForm } from 'src/components/LicenseConfig/shared/ConfigForm/ConfigForm';
import { configFieldLabels, configFieldKeys } from 'src/components/LicenseConfig/shared/configFields';

interface AccountConfigDisplayPropsType {
    state: AccountConfigState;
}

export const AccountConfigDisplay = observer(({ state }: AccountConfigDisplayPropsType): JSX.Element => {
    const config = state.config;
    if (config === null) {
        return (
            <LoadingV2
                title='Loading configuration...'
                dataTest='account-config-loading'
            />
        );
    }

    const displayCurrency = config.currency ?? state.walletCurrency ?? null;

    const fields = configFieldKeys.map((field) => ({
        key: field,
        label: configFieldLabels[field],
        formInputState: state[field],
        originalValue: config[field] ?? '',
    }));

    return (
        <div>
            {state.errorMessage !== null && state.errorMessage !== '' && (
                <AlertWrapper>
                    <Alert
                        variant='destructive'
                        title='Error'
                        icon='info'
                    >
                        {state.errorMessage}
                    </Alert>
                </AlertWrapper>
            )}

            <ConfigForm
                title='Account Configuration'
                tooltip='Has higher priority than global configuration. Individual limits can be set - if a limit is empty, it falls back to the global limit. Global config is available in Admin > License Config (superuser access required).'
                currency={displayCurrency}
                fields={fields}
                isSaving={state.isSaving}
                onSubmit={state.updateConfig}
            />
        </div>
    );
});
